import gql from 'graphql-tag';
import { Injectable } from '@angular/core';

import { BackendService } from '../new-http/backend.service';
import { IAvailableStrategy } from '../../interfaces/infoproducts/strategy.interfaces';

@Injectable({ providedIn: 'root' })
export class InfoproductsStrategyService extends BackendService {

    /**
     * Busca todas as estratégias disponíveis
     *
     * @returns
     */
    public async getAvailableStrategies(): Promise<IAvailableStrategy[]> {

        const { data } = await this.graphqlApi.query({
            fetchPolicy: 'network-only',
            query: gql`
                query {
                    availableStrategies {
                        id
                        name
                        link
                        order
                        coverUrl
                        accessLink
                        mostViewed
                        description
                        profitability
                        coverMobileUrl
                        isAllowedToCustomer
                        group {
                            id
                            name
                            description
                        }
                        category {
                            id
                            name
                        }
                        specialists {
                            id
                            name
                            about
                            heroImageUrl
                            profilePhotoUrl
                        }
                        pricing {
                            current
                            promotion
                            refundTime
                        }
                        descriptors {
                            icon
                            title
                            subtitle
                        }
                    }
                }
            `,
        });

        return data.availableStrategies;

    }

}
